import { SET_ERROR_FROM_GQL, setErrorFromGQLAction } from 'actions/errorAction'
import {
  ForeignProfileHitTypes,
  SET_IMAGE_URL_WIDGET_THIS_IS_ME,
  TOGGLE_UPDATE_FOREIGN_PROFILE,
} from 'actions/foreignProfile/foreignProfileAction'
import {
  CLEAN_FOREIGN_PROFILE,
  cleanForeignProfileAction,
} from 'actions/profileAction'
import {
  PromoServiceAvailableTypes,
  SAVE_PROMO_SERVICE_AVAILABLE,
} from 'actions/promoServiceAvailable/promoServiceAvailableAction'
import {
  GiftsUserComet,
  SOCKET_RECEIVE_DATA,
  SocketData,
  SocketReceiveDataTypes,
} from 'actions/socket/socketReceiveDataAction'
import {
  LocalStorageActionTypes,
  RESTORE_PARTIAL_STATE,
} from 'actions/system/localStorageAction'
import {
  RESTORE_INITIAL_STATE,
  RestoreInitialStateAction,
} from 'actions/system/restoreInitialStateAction'
import { createGiftUserChannel } from 'functions/comet'
import { initialStateReducer } from 'reducers/default/initialStateReducer'
import {
  ForeignProfileState,
  initialState,
} from 'reducers/foreignProfile/ForeignProfileState'
import { filterCometMessages } from 'reducers/functions'

export const foreignProfileReducer = (
  state = initialState,
  action:
    | ForeignProfileHitTypes
    | PromoServiceAvailableTypes
    | LocalStorageActionTypes
    | RestoreInitialStateAction
    | ReturnType<typeof setErrorFromGQLAction>
    | ReturnType<typeof cleanForeignProfileAction>
    | SocketReceiveDataTypes
): ForeignProfileState => {
  switch (action.type) {
    case SAVE_PROMO_SERVICE_AVAILABLE:
      return {
        ...state,
        availablePromoServices: action.availablePromoServices,
      }

    case SET_IMAGE_URL_WIDGET_THIS_IS_ME:
      return {
        ...state,
        imageUrlWidget: action.url,
      }

    case TOGGLE_UPDATE_FOREIGN_PROFILE:
      return {
        ...state,
        updateProfile: action.value,
      }

    case SET_ERROR_FROM_GQL:
      /** Ограничиваюсь известными ошибками */
      if (
        ['limit_exceeded', 'ignored_user_restriction'].includes(action.value)
      ) {
        return {
          ...state,
          gqlError: action.value,
        }
      }

      return state

    case CLEAN_FOREIGN_PROFILE:
      return {
        ...state,
        gqlError: null,
      }

    case SOCKET_RECEIVE_DATA:
      const socketResult = action.result
      const userId = action.userId

      const [giftUserMessage] = filterCometMessages<GiftsUserComet>(
        socketResult as SocketData<GiftsUserComet>[],
        createGiftUserChannel(userId)
      )

      if (giftUserMessage?.content?.to_user_id) {
        return { ...state, updateProfile: true }
      }

      return state

    case RESTORE_INITIAL_STATE:
      return initialStateReducer(state, action, 'foreignProfile')

    case RESTORE_PARTIAL_STATE:
      if (action.name === nameReducer) {
        return {
          ...state,
          ...action.partialState.foreignProfile,
        }
      }

      return state

    default:
      return state
  }
}

const nameReducer = 'foreignProfile'
